import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, of, forkJoin } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, share } from "rxjs/operators";
import { Router } from "@angular/router";

import {
  GlobalDomOpsService,
  CommonOperationsService,
  GlobalDataOpsService,
  AcepSSOService
} from "@acepteam/globalspack";
import { HelperService, LoggerService, DataService } from "../../core/services";

import {
  MemberAppData,
  MembershipDetails,
  EducationDetails
} from "../../shared/models";
import {
  MapMemberAppData,
  MapChapterDetails,
  MapSectionDetails,
  MapMembershipDetails
} from "../helpers/mapper";

declare var $: any;
declare var moment: any;

@Injectable({
  providedIn: "root"
})
export class EmailHelperService {
  //Email
  private email_from = "donotreply@acep.org";
  private email_to = this.globalDataOpsService.isTestEnvironment
    ? "membership@acep.org"
    : "membership@acep.org";
  private email_cc = this.globalDataOpsService.isTestEnvironment
    ? "devops@acep.org"
    : "devops@acep.org";

  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private globalDataOpsService: GlobalDataOpsService,
    private commonOpsService: CommonOperationsService,
    private dataService: DataService,
    private helperService: HelperService,
    private titleService: Title,
    private loggerService: LoggerService,
    private http: HttpClient,
    private router: Router
  ) { }

  public SendManualEmailContentIfAny(memberAppData: MemberAppData) {
    let ed: EducationDetails = memberAppData.educationDetails;
    let html = "";
    //Medical School//
    if (ed.medicalSchool.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(
        ed.medicalSchool,
        "MEDICAL SCHOOL"
      );
    }
    //Resdiency//
    if (ed.residency.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(ed.residency, "RESIDENCY");
    }
    //Fellowship//

    if (ed.fellowship.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(
        ed.fellowship,
        "FELLOWSHIP"
      );
    }

    if (html != "") {
      let htmlManual = "";

      htmlManual +=
        "<h3>A request to add a new institution has been submitted through the ACEP/EMRA Member Application.</h3><br/>";
      htmlManual +=
        "<b>Please find below the details of the request:</b><br />";
      htmlManual += "<table>";
      htmlManual += `<tr><td>ACEP ID:</td><td>${this.ssoService.acepid
        }</td><tr>`;
      htmlManual += `<tr><td>Member Name:</td><td>${memberAppData.personalInfo.firstName
        } ${memberAppData.personalInfo.lastName}</td><tr>`;

      htmlManual += html;

      htmlManual += "</table>";

      htmlManual = btoa(htmlManual);

      this.globalDataOpsService
        .SendEmail(
          this.ssoService.contactid,
          this.email_from,
          this.email_to,
          this.email_cc,
          "ACEP Member Application-Add New Institution Request-" +
          this.ssoService.acepid,
          htmlManual
        )
        .subscribe(() => {
          this.loggerService.logInfo("Email Sent about Manual Programs");
        });
    }
  }

  private ExtractHtmlFromManualProgramJson(json: any, type: any) {
    let html = "<hr/>";
    html += `<tr><td colspan='2'><h4>${type}</h4></td><tr>`;
    html += `<tr><td>Name:</td><td>${json.address.name || json.name}</td><tr>`;
    html += `<tr><td>Address Line 1:</td><td>${json.address.address1}</td><tr>`;
    html += `<tr><td>Address Line 2:</td><td>${json.address.address2}</td><tr>`;
    html += `<tr><td>City:</td><td>${json.address.city}</td><tr>`;
    html += `<tr><td>State/Province:</td><td>${json.address.state}</td><tr>`;
    html += `<tr><td>Country:</td><td>${json.address.country}</td><tr>`;
    html += `<tr><td>Postal Code:</td><td>${json.address.zip}</td><tr>`;
    return html;
  }

  RunOrderReceiptWorkflow(memberAppData: MemberAppData) {
    //workflow name based on new app or renewal
    let _workflowname =
      memberAppData.profile.membership.ExpirationDate == ""
        ? "Email Membership application Receipt"
        : "Email Membership Receipt";
    let _orderid = memberAppData.orderDetails.OrderId;
    let jpayload = { orderid: _orderid, workflowname: _workflowname };

    this.http
      .post(
        this.dataService.memberappapiendpoint.replace(
          "acepmemberappapi",
          "sempamemberappapi"
        ) + "RunOrderWorkflow",
        jpayload
      )
      .subscribe(() => {
        console.info("Order Receipt workflow executed");
      });
  }
}
